import useAuth from '../components/hooks/useAuth'
import { Navbar, Nav , NavDropdown, Button} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import swal from 'sweetalert';

const NavigationBar = () => {
    const { cerrarSesionAuth } = useAuth()

    const handleCerrarSesion = () => {
        swal({

            text: "Deseas cerrar sesion?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                cerrarSesionAuth()
                localStorage.removeItem('token')
            } 
          });


    }
    
    const perfil = localStorage.getItem('perfil')
    
  return (
    <Navbar  bg="dark" variant="dark" expand="lg" >
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav" >
        <Nav className="mr-auto"  >
            <LinkContainer to="/prestamos">
                <Nav.Link >Home</Nav.Link>
            </LinkContainer>
            <LinkContainer to="clientes">
                <Nav.Link>Clientes</Nav.Link>
            </LinkContainer>
            <LinkContainer to="Gastos">
                <Nav.Link>Gastos</Nav.Link>
            </LinkContainer>      
            <NavDropdown title="Créditos" id="basic-nav-dropdown">
            <LinkContainer to="NuevoPrestamo">
            <NavDropdown.Item>Nuevo Crédito</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="PrestamosActivos">
            <NavDropdown.Item>Créditos Activos</NavDropdown.Item>
            </LinkContainer>
       
            <LinkContainer to="ProximosVencimientos">
            <NavDropdown.Item>Proximos Vencimientos</NavDropdown.Item>
            </LinkContainer> 
            <LinkContainer to="PrestamosFinalizados">
            <NavDropdown.Item>Historial Crédito</NavDropdown.Item>
            </LinkContainer>
            </NavDropdown>
            <LinkContainer to="Productos">
                <Nav.Link>Productos</Nav.Link>
            </LinkContainer> 
            <NavDropdown title="Ventas" id="basic-nav-dropdown">
            <LinkContainer to="NuevaVenta">
            <NavDropdown.Item>Crear Venta</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="VentasEnCurso">
            <NavDropdown.Item>Ventas Activas</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="HistorialVentas">
            <NavDropdown.Item>Historial Ventas</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="ProximosVencimientosVentas">
            <NavDropdown.Item>Proximos Vencimientos</NavDropdown.Item>
            </LinkContainer> 
            </NavDropdown> 
         
            {perfil !== "user" && (
            <NavDropdown title="Informes" id="basic-nav-dropdown">
            <LinkContainer to="InformeGastos">
            <NavDropdown.Item>Informe Gastos</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="InformePrestamos">
            <NavDropdown.Item>Informe Créditos</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="InformeVentas">
            <NavDropdown.Item>Informe Ventas</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="InformeVentasActivas">
            <NavDropdown.Item>Informe Ventas Activas</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="GananciaReal">
            <NavDropdown.Item>Ganancia Real</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="MediosPago">
            <NavDropdown.Item>Informe Medios de Pago</NavDropdown.Item>
            </LinkContainer>
            </NavDropdown>
            )}
                  <LinkContainer to="GeneradorConsulta">
                <Nav.Link >Generador de consulta</Nav.Link>
            </LinkContainer>      
            <LinkContainer to="SupervisorPagos">
                <Nav.Link >Supervisor Pagos</Nav.Link>
            </LinkContainer> 
            <LinkContainer to="ResumenCliente">
                <Nav.Link >Resumen Cliente</Nav.Link>
            </LinkContainer>      
            <LinkContainer to="AnalisisClientes">
                <Nav.Link >Analisis Clientes</Nav.Link>
            </LinkContainer>
        </Nav>
        
    </Navbar.Collapse>
    <Button   style={{ background: "#005187", color: "white" ,padding: "0.4rem", marginRight: "10px", border:"black"}} onClick={handleCerrarSesion}>
        Cerrar Sesión
    </Button>

</Navbar>
  )
}

export default NavigationBar